// extracted by mini-css-extract-plugin
export default {"wrapper":"DefaultFullBannerHomeLayout_wrapper__aywI7","banner":"DefaultFullBannerHomeLayout_banner__XE4Oy","content":"DefaultFullBannerHomeLayout_content__w2l2J"};